import type { ComponentProps, PropsWithChildren } from 'react'
import React, { forwardRef } from 'react'
import styled from 'styled-components'
import _DropdownSheet, { DROPDOWN_SHEET_MAX_HEIGHT_CSS_VARIABLE, DROPDOWN_SHEET_MAX_WIDTH_CSS_VARIABLE, DROPDOWN_SHEET_MIN_HEIGHT_CSS_VARIABLE, DROPDOWN_SHEET_MIN_WIDTH_CSS_VARIABLE, DROPDOWN_SHEET_WIDTH_CSS_VARIABLE } from '../_DropdownSheet'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import clsx from 'clsx'
import { setCSSVar } from 'lib/theme/themeUtils'

const Container = styled(_DropdownSheet)`
  ${setCSSVar(DROPDOWN_SHEET_WIDTH_CSS_VARIABLE, 'auto')}

  ${mediaQueryUp.tablet} {
    ${setCSSVar(DROPDOWN_SHEET_MIN_WIDTH_CSS_VARIABLE, rem(280))}
  }

  &:not(.auto-height) {
    ${setCSSVar(DROPDOWN_SHEET_MIN_HEIGHT_CSS_VARIABLE, rem(200))}
    ${setCSSVar(DROPDOWN_SHEET_MAX_HEIGHT_CSS_VARIABLE, rem(480))}

    ${mediaQueryUp.tablet} {
      ${setCSSVar(DROPDOWN_SHEET_MIN_HEIGHT_CSS_VARIABLE, rem(200))}
      ${setCSSVar(DROPDOWN_SHEET_MAX_HEIGHT_CSS_VARIABLE, rem(584))}
    }
  }

  &.size-S {
    ${setCSSVar(DROPDOWN_SHEET_MIN_WIDTH_CSS_VARIABLE, rem(200))}
    ${setCSSVar(DROPDOWN_SHEET_MAX_WIDTH_CSS_VARIABLE, rem(335))}

    ${mediaQueryUp.tablet} {
      ${setCSSVar(DROPDOWN_SHEET_MIN_WIDTH_CSS_VARIABLE, rem(220))}
      ${setCSSVar(DROPDOWN_SHEET_MAX_WIDTH_CSS_VARIABLE, rem(335))}
    }
  }
  &.size-M {
    ${setCSSVar(DROPDOWN_SHEET_MIN_WIDTH_CSS_VARIABLE, rem(335))}
    ${setCSSVar(DROPDOWN_SHEET_MAX_WIDTH_CSS_VARIABLE, rem(335))}

    ${mediaQueryUp.tablet} {
      ${setCSSVar(DROPDOWN_SHEET_MIN_WIDTH_CSS_VARIABLE, rem(400))}
      ${setCSSVar(DROPDOWN_SHEET_MAX_WIDTH_CSS_VARIABLE, rem(600))}
    }
  }
  &.size-L {
    ${setCSSVar(DROPDOWN_SHEET_WIDTH_CSS_VARIABLE, rem(1140))}
  }

  &.size-XL {
    ${setCSSVar(DROPDOWN_SHEET_WIDTH_CSS_VARIABLE, rem(1140))}
    ${setCSSVar(DROPDOWN_SHEET_MAX_HEIGHT_CSS_VARIABLE, rem(540))}

    ${mediaQueryUp.tablet} {
      ${setCSSVar(DROPDOWN_SHEET_MAX_HEIGHT_CSS_VARIABLE, rem(640))}
    }
  }

  &.size-content {
    ${setCSSVar(DROPDOWN_SHEET_MAX_HEIGHT_CSS_VARIABLE, 'unset')}
  }

  &.size-fill-anchor {
    ${setCSSVar(DROPDOWN_SHEET_WIDTH_CSS_VARIABLE, '100%')}
  }
`

type InheritedBaseSheetProps = Pick<ComponentProps<typeof _DropdownSheet>, 'height'>

interface Props extends PropsWithChildren, InheritedBaseSheetProps {
  /**
   * Controls the width and height of the sheet
   */
  size: 'S' | 'M' | 'L' | 'XL' | 'fill-anchor' | 'content'
  autoHeight?: boolean
}

const DropdownSheetSheet = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    children,
    height,
    size,
    autoHeight,
  } = props

  return <Container
    ref={ref}
    className={clsx(`size-${size}`, { 'auto-height': autoHeight })}
    height={height}
    data-size={size}
  >
    {children}
  </Container>
})

export default DropdownSheetSheet
